import React, { useEffect, useRef } from 'react'
import { animateRemoteWorkChart } from './functions/useRemoteWorkAnimation'
import styles from './RemoteWorkPieChart.module.scss'

export const StyledRemoteWorkPieChart: React.FC = () => {
  const chartBackground = useRef<HTMLDivElement>(null)
  const percentRef = useRef<HTMLDivElement>(null)

  const handleScroll = () => {
    if (!chartBackground.current || !percentRef.current) {
      return
    }

    const rect = chartBackground.current.getBoundingClientRect()
    const center = (rect.top + rect.bottom) / 2

    if (chartBackground.current.dataset.animationStarted) {
      return
    }

    if (0 < center && center < window.innerHeight) {
      chartBackground.current.dataset.animationStarted = 'true'
      animateRemoteWorkChart(chartBackground, percentRef)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={`flex justify-center items-center rounded-FULL ${styles.pieChartBackground}`} ref={chartBackground}>
      <div className={`bg-member-gray-0 rounded-FULL flex flex-col justify-center items-center text-member-green-100 ${styles.pieChartInner}`}>
        <div ref={percentRef} className={`font-bold ${styles.pieChartPercent}`}>
          0
        </div>
        <div className={`font-bold ${styles.remoteWorkText}`}>Remote work</div>
      </div>
    </div>
  )
}
